import { Box } from "@mui/material"
import type { ReactElement } from "react"
import React, { useMemo } from "react"
import { useFormContext } from "react-hook-form"

import AutoComplete from "@/components/common/Autocomplete/AutoComplete"
import { DEFAULT_AUTOCOMPLETE_VALUE } from "@/constants/forms"
import useProductManager from "@/hooks/api/useProductManager"
import type { ProductManagerFormValue } from "@/screens/ManageProducts/components/ProductClasses/forms/classSchema"
import type { AutocompleteOption } from "@/types/form-fields"
import { getAutoCompleteOptionLabel } from "@/utils/forms"

const ProductManagerSelect = (): ReactElement => {
  const { control } = useFormContext()
  const { productManagerList, fetching } = useProductManager({ isAs400ProductManager: true })

  const optionsList: ProductManagerFormValue[] = useMemo(() => {
    return (
      productManagerList?.map(({ name, userId }) => {
        return {
          label: name,
          id: userId,
        }
      }) ?? []
    )
  }, [productManagerList])

  return (
    <Box>
      <AutoComplete<AutocompleteOption>
        label='Product Manager'
        placeholder='Select Product Manager'
        name='productManager'
        id='productManager'
        options={optionsList}
        getOptionLabel={getAutoCompleteOptionLabel}
        control={control}
        clearOnEscape={true}
        defaultEmptyState={DEFAULT_AUTOCOMPLETE_VALUE}
        loading={fetching}
        required
      />
    </Box>
  )
}

export default ProductManagerSelect
